const Feed = () => {
  return <div>여기는 피드입니다.</div>;
};

export default Feed